export default __webpack_public_path__ + "static/media/5.a4ef7264.png";